export enum ProductInfobarHeaders {
    Prices = 1,
    Inventory = 2,
    Edit = 3
}
